import { render } from "./OnboardingAd.vue?vue&type=template&id=f677f796"
import script from "./OnboardingAd.vue?vue&type=script&lang=js"
export * from "./OnboardingAd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/OnboardingAd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f677f796"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f677f796', __exports__)) {
    api.reload('f677f796', __exports__)
  }
  
  module.hot.accept("./OnboardingAd.vue?vue&type=template&id=f677f796", () => {
    api.rerender('f677f796', render)
  })

}


export default __exports__